import React, { useState, useEffect } from "react";
import axios from "axios";
import Scrollbar from "../scrollbar";
import { MdCheckCircleOutline } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import Loader from "../Loader";
import EmptyState from "./emptyState";
import { FaSearch } from "react-icons/fa";
import { getAllProviderData_ } from "../../utils/apis/func";

const DeclinedProviders = () => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [providers, setProviders] = useState([]);
  const [loading, setLoading] = useState(false);
  const itemsPerPage = 10;

  useEffect(() => {
    fetchDeclinedProviders();
  }, []);

  const fetchDeclinedProviders = async () => {
    setLoading(true);
    const AuthToken = localStorage.getItem("AuthToken");
    try {
      const res = await axios({
        method: "get",
        url: "https://api.pureworker.com/api/admin/providers?isVerified=rejected",
        headers: {
          Authorization: `Bearer ${AuthToken}`,
        },
      });
      setProviders(res?.data?.providers?.results || []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleGet = async (id: any) => {
    setLoading(true);
    const res = await getAllProviderData_(id);
    if (res?.status === 200 || res?.status === 201) {
      navigate(`/verification/${id}`);
    }
    setLoading(false);
  };

  const filteredBusinesses =
    searchTerm.length > 0
      ? providers.filter((item: any) =>
          item?.businessName?.toLowerCase()?.includes(searchTerm.toLowerCase())
        )
      : providers.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  const handlePrevPageClick = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPageClick = () => {
    const totalPages = Math.ceil(providers.length / itemsPerPage);
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  return (
    <>
      <div className="mb-4">
        <div className="ml-10 flex items-center sm:flex">
          <FaSearch className="text-[#88087B]" />
          <input
            type="text"
            className="rounded-full ml-4 px-4 py-2 sm:w-48 lg:w-70 font-roboto text-sm font-normal leading-5 tracking-tighter text-[#8E8E93] focus:outline-none"
            placeholder="Search Rejected"
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>
      {providers.length === 0 && !loading && (
        <EmptyState
          title={"No Rejected Providers"}
          text={"Rejected providers will be displayed here."}
        />
      )}
      {providers.length > 0 && (
        <div className="">
          <section className="">
            <div className="overflow-x-auto rounded-t-lg">
              <table className="w-full">
                <thead className="bg-[#88087B] text-[#F7F7F7] font-roboto text-md font-medium">
                  <tr>
                    <th className="py-3 px-4">Name</th>
                    <th className="py-3 px-4">Phone Number</th>
                    <th className="py-3 px-4">Email</th>
                    <th className="py-3 px-4"></th>
                  </tr>
                </thead>
                <tbody>
                  {filteredBusinesses.map((item: any) => (
                    <tr
                      key={item.id}
                      onClick={async () => {
                        await handleGet(item.id || item._id);
                      }}
                      className="hover:bg-[#87878d] transition duration-300 font-roboto text-xs font-medium leading-normal text-center"
                    >
                      <td className="py-2 px-4">
                        {item.firstName
                          ? `${item.firstName} ${item.lastName}`
                          : item.businessName}
                      </td>
                      <td className="py-2 px-4">{item?.phoneNumber}</td>
                      <td className="py-2 px-4">{item.email}</td>
                      <td className="py-2 px-4">
                        <MdCheckCircleOutline size={20} className="text-[#88087B]" />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <Scrollbar
              currentPage={currentPage}
              totalPages={Math.ceil(providers.length / itemsPerPage)}
              itemsPerPage={itemsPerPage}
              totalItems={providers.length}
              onPrevPageClick={handlePrevPageClick}
              onNextPageClick={handleNextPageClick}
            />
          </section>
        </div>
      )}
      {loading && <Loader />}
    </>
  );
};

export default DeclinedProviders;
